import { render, staticRenderFns } from "./QCSetting.vue?vue&type=template&id=d880bfd0&scoped=true&"
import script from "./QCSetting.vue?vue&type=script&lang=js&"
export * from "./QCSetting.vue?vue&type=script&lang=js&"
import style0 from "./QCSetting.vue?vue&type=style&index=0&id=d880bfd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d880bfd0",
  null
  
)

export default component.exports